<div class="close_container flex_between_align_center text_title_middle">
  <span *ngIf="title">{{title | translate}}</span>
  <button class="close_btn br_50 pointer flex_center_align_center"  (click)="closeButton.emit()" >
    <img src="assets/images/icons/close_icon.svg">
  </button>
</div>
